(() => {
  const targetNode = document.querySelector(".instagram-landing__wrapper");
  const navButtons = document.querySelector(".instagram-landing__arrows");

  const callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches(".fs-has-posts")) {
            console.log("Observed element added:", node);
            prevButtonObserve();
            addListeners();
            navButtons
              .querySelector(".instagram-landing__button-prev")
              .classList.remove("button-lock");
            navButtons
              .querySelector(".instagram-landing__button-next")
              .classList.remove("button-lock");

            observer.disconnect();
          }
        });
      }
    }
  };

  const observer = new MutationObserver(callback);

  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);

  function prevButtonObserve() {
    const targetNodeClass = document.querySelector(".fs-slider-prev-button");
    console.log("node", targetNodeClass);
    const callbackClass = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (mutation.target.classList.contains("fs-hidden")) {
            navButtons
              .querySelector(".instagram-landing__button-prev")
              .classList.add("button-disabled");
          } else {
            navButtons
              .querySelector(".instagram-landing__button-prev")
              .classList.remove("button-disabled");
          }
        }
      }
    };

    const observerClass = new MutationObserver(callbackClass);

    const configClass = { attributes: true, attributeFilter: ["class"] };

    observerClass.observe(targetNodeClass, configClass);
  }

  function addListeners() {
    navButtons.addEventListener("click", onNavigation);
  }

  function onNavigation(e) {
    const target = e.target;
    const prevButtonSlider = document.querySelector(".fs-slider-prev-button");
    const nextButtonSlider = document.querySelector(".fs-slider-next-button");
    if (target.closest(".instagram-landing__button-prev")) {
      prevButtonSlider.click();
    }
    if (target.closest(".instagram-landing__button-next")) {
      nextButtonSlider.click();
    }
  }
})();
